import { Component, Input } from '@angular/core';
import { FilterModelDto } from '../../../../models/filter.model';

@Component({
  selector: 'app-payment-page-filter',
  templateUrl: './payment-page-filter.component.html',
  styleUrls: ['./payment-page-filter.component.scss'],
})
export class PaymentPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined;
  @Input() filterPaymentTypes: FilterModelDto[] | undefined;
  @Input() filterDirections: FilterModelDto[] | undefined;
  @Input() filterBanks: FilterModelDto[] | undefined;
  @Input() filterCurrencies: FilterModelDto[] | undefined;

  filterSumFrom: FilterModelDto = {
    fieldName: 'sum_from',
    value: '',
    description: '',
  };

  filterSumTo: FilterModelDto = {
    fieldName: 'sum_to',
    value: '',
    description: '',
  };

  filterStart: FilterModelDto = {
    fieldName: 'date_from',
    value: '',
    description: '',
  };

  filterEnd: FilterModelDto = {
    fieldName: 'date_to',
    value: '',
    description: '',
  };
}
